var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("jet-action-section", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v(" Two Factor Authentication ")]
        },
        proxy: true,
      },
      {
        key: "description",
        fn: function () {
          return [
            _vm._v(
              "\n        Add additional security to your account using two factor\n        authentication.\n    "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _vm.twoFactorEnabled
              ? _c("h3", { staticClass: "text-lg font-medium text-gray-900" }, [
                  _vm._v(
                    "\n            You have enabled two factor authentication.\n        "
                  ),
                ])
              : _c("h3", { staticClass: "text-lg font-medium text-gray-900" }, [
                  _vm._v(
                    "\n            You have not enabled two factor authentication.\n        "
                  ),
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 max-w-xl text-sm text-gray-600" }, [
              _c("p", [
                _vm._v(
                  "\n                When two factor authentication is enabled, you will be\n                prompted for a secure, random token during authentication.\n                You may retrieve this token from your phone's Google\n                Authenticator application.\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.twoFactorEnabled
              ? _c("div", [
                  _vm.qrCode
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "mt-4 max-w-xl text-sm text-gray-600",
                          },
                          [
                            _c("p", { staticClass: "font-semibold" }, [
                              _vm._v(
                                "\n                        Two factor authentication is now enabled. Scan the\n                        following QR code using your phone's authenticator\n                        application.\n                    "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "mt-4",
                          domProps: { innerHTML: _vm._s(_vm.qrCode) },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recoveryCodes.length > 0
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "mt-4 max-w-xl text-sm text-gray-600",
                          },
                          [
                            _c("p", { staticClass: "font-semibold" }, [
                              _vm._v(
                                "\n                        Store these recovery codes in a secure password\n                        manager. They can be used to recover access to your\n                        account if your two factor authentication device is\n                        lost.\n                    "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "grid gap-1 max-w-xl mt-4 px-4 py-4 font-mono text-sm bg-gray-100 rounded-lg",
                          },
                          _vm._l(_vm.recoveryCodes, function (code, idx) {
                            return _c("div", { key: idx }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(code) +
                                  "\n                    "
                              ),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mt-5" }, [
              !_vm.twoFactorEnabled
                ? _c(
                    "div",
                    [
                      _c(
                        "jet-confirms-password",
                        {
                          on: { confirmed: _vm.enableTwoFactorAuthentication },
                        },
                        [
                          _c(
                            "jet-button",
                            {
                              class: { "opacity-25": _vm.enabling },
                              attrs: { type: "button", disabled: _vm.enabling },
                            },
                            [
                              _vm._v(
                                "\n                        Enable\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "jet-confirms-password",
                        { on: { confirmed: _vm.regenerateRecoveryCodes } },
                        [
                          _vm.recoveryCodes.length > 0
                            ? _c(
                                "jet-secondary-button",
                                { staticClass: "mr-3" },
                                [
                                  _vm._v(
                                    "\n                        Regenerate Recovery Codes\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "jet-confirms-password",
                        { on: { confirmed: _vm.showRecoveryCodes } },
                        [
                          _vm.recoveryCodes.length == 0
                            ? _c(
                                "jet-secondary-button",
                                { staticClass: "mr-3" },
                                [
                                  _vm._v(
                                    "\n                        Show Recovery Codes\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "jet-confirms-password",
                        {
                          on: { confirmed: _vm.disableTwoFactorAuthentication },
                        },
                        [
                          _c(
                            "jet-danger-button",
                            {
                              class: { "opacity-25": _vm.disabling },
                              attrs: { disabled: _vm.disabling },
                            },
                            [
                              _vm._v(
                                "\n                        Disable\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }